import { Injectable } from '@angular/core';
import {RankingListItem} from "../interfaces/ranking-list-item";
import {RankingRequestResponse} from "../interfaces/ranking-request-response";
import {RankingInfo} from "../interfaces/ranking-info";
import {OverlayService} from "../overlay/overlay.service";
import {RankingListComponent} from "../shared/ranking-list-block/ranking-list/ranking-list.component";
import {
  RankingListOverlayHeaderComponent
} from "../shared/ranking-list-block/ranking-list/ranking-list-overlay-header/ranking-list-overlay-header.component";
import {
  RankingListOverlayFooterComponent
} from "../shared/ranking-list-block/ranking-list/ranking-list-overlay-footer/ranking-list-overlay-footer.component";
import {DataService} from "./data.service";
import {take} from "rxjs";
import {SchoolClassParserService} from "./school-class-parser.service";
import {SchoolClassRank} from "../interfaces/backend/school-class-rank";

@Injectable({
  providedIn: 'root'
})
export class RankingService {

  constructor(private overlay: OverlayService, private data: DataService, private schoolClassParserService: SchoolClassParserService) { }

  async getRankingExcerpt(relativeOrganizationId: number): Promise<RankingInfo> {
    return await new Promise(async (resolve, reject) => {
      this.data.getSchoolClassRankings().pipe(take(1)).subscribe((response) => {
        const excerptTotalCount = 7; // show 7 classes in excerpt (3 above, 3 below and current in the middle)
        let aboveCount = Math.floor((excerptTotalCount - 1) / 2);
        let belowCount = excerptTotalCount - 1 - aboveCount;
        //console.warn("response", response);

        let mappedResponse = this.mapRequestResponse(response);

        const currentClass = mappedResponse.ranking.filter((el) => el.schoolClassData.id === relativeOrganizationId);
        if(currentClass.length === 1) {
          const currentPosition = currentClass[0].position;
          let abovePointer = currentPosition - aboveCount;
          let belowPointer = currentPosition + belowCount;

          if(abovePointer < 1) { // check if  overflow on top
            let additionalBelow = 1 - abovePointer; // overflow size

            abovePointer = 1; // set above pointer to the top
            belowPointer+= additionalBelow; // add overflow size to below pointer

          }
          if(belowPointer > mappedResponse.totalOrganizations) { // now if we have overflow below (either on start or after manipulation in previous if)
            let additionalAbove = belowPointer - mappedResponse.totalOrganizations; // get overflow size

            belowPointer = mappedResponse.totalOrganizations; // set pointer to the end

            abovePointer-= additionalAbove; // move upper pointer on overflow size

            if(abovePointer < 1) abovePointer = 1; // if it caused overflow on top then just set to top
          }


          // console.log(mappedResponse.ranking[13]);

          let excerptResponse = mappedResponse;
          excerptResponse.ranking = excerptResponse.ranking.slice(abovePointer - 1, belowPointer);
          resolve(excerptResponse);

        }

        resolve(mappedResponse);

      })
    })
  }

  async getFullRanking(): Promise<RankingInfo> {
    return await new Promise(async (resolve, reject) => {
      this.data.getSchoolClassRankings().pipe(take(1)).subscribe((response) => {
        console.warn("response", response);
        const mappedResponse = this.mapRequestResponse(response);
        console.warn("mappedResponse", mappedResponse);
        resolve(mappedResponse);
      });
    })
  }

  openRankingOverlay(): void {
    // create empty component, then after data load create next component

    this.overlay.openWindowOverlay({
      theme: "game",
      componentMain: {
        component: RankingListComponent,
        data: {
          items: [],
          isOverlay: true
        }
      },
      componentHeader: {
        component: RankingListOverlayHeaderComponent,
      },
      componentFooter: {
        component: RankingListOverlayFooterComponent
      }
    });

    this.getFullRanking().then((val) => {
      this.overlay.removeLastComponent();

      this.overlay.openWindowOverlay({
        theme: "game",
        componentMain: {
          component: RankingListComponent,
          data: {
            items: val.ranking,
            isOverlay: true
          }
        },
        componentHeader: {
          component: RankingListOverlayHeaderComponent,
        },
        componentFooter: {
          component: RankingListOverlayFooterComponent
        }
      });
    });
  }



  private mapRequestResponse(response: SchoolClassRank[] | false): RankingInfo {
    const rankings = response || [];
    // deterministic order on equal points - must match the sorting in the backend (SchoolClassRankings.php)
    const ranking = rankings.sort((a, b) => {
      return (b.points - a.points) || (a.schoolClass.id - b.schoolClass.id);
    })
    .map((el, idx): RankingListItem => {
      return {
        schoolClassData: this.schoolClassParserService.mapRawRankedSchoolClass(el.schoolClass, el.school.name),
        position: idx + 1,
        difference: "NONE",
        playedTime: el.playtimeMinutes ?? 0,
        points: el.points
      }
    });

    return {
      ranking: ranking,
      totalOrganizations: rankings.length
    };
  }

}
